module.exports = __webpack_public_path__ + "static/media/25_A.0ef09b04.png";